/* Galería del producto: carrusel principal + tira de miniaturas.
   NO se mueve sola nunca: solo con el dedo, con las miniaturas o con
   las flechas. ~1,3 KB. */
(function () {
  'use strict';

  function montar(g) {
    var pista = g.querySelector('[data-gal-pista]');
    if (!pista) return;

    var items = pista.children;
    if (!items.length) return;

    var minis = g.querySelector('[data-gal-minis]');
    var puntos = g.querySelector('[data-gal-puntos]');
    var prev = g.querySelector('[data-gal-prev]');
    var next = g.querySelector('[data-gal-next]');
    var btnMini = minis ? minis.querySelectorAll('[data-gal-ir]') : [];
    var btnPunto = puntos ? puntos.children : [];
    var i = 0;

    function marcar(k) {
      if (k < 0 || k >= items.length) return;
      i = k;
      for (var j = 0; j < btnMini.length; j++) btnMini[j].classList.toggle('on', j === k);
      for (var m = 0; m < btnPunto.length; m++) {
        btnPunto[m].classList.toggle('on', m === k);
        btnPunto[m].setAttribute('aria-current', m === k ? 'true' : 'false');
      }
      if (btnMini[k] && minis) {
        var b = btnMini[k].getBoundingClientRect(), c = minis.getBoundingClientRect();
        if (b.left < c.left || b.right > c.right) {
          minis.scrollBy({ left: b.left - c.left - (c.width - b.width) / 2, behavior: 'smooth' });
        }
      }
      if (prev) prev.disabled = k <= 0;
      if (next) next.disabled = k >= items.length - 1;
    }

    function ir(k) {
      if (items[k]) items[k].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) marcar(Array.prototype.indexOf.call(items, e.target));
        });
      }, { root: pista, threshold: 0.6 });
      for (var k = 0; k < items.length; k++) io.observe(items[k]);
    }

    for (var n = 0; n < btnMini.length; n++) {
      (function (j) { btnMini[j].addEventListener('click', function () { ir(j); }); })(n);
    }
    if (puntos) puntos.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (b) ir(Array.prototype.indexOf.call(btnPunto, b));
    });
    if (prev) prev.addEventListener('click', function () { ir(i - 1); });
    if (next) next.addEventListener('click', function () { ir(i + 1); });

    marcar(0);
  }

  function iniciar() { document.querySelectorAll('[data-gal]').forEach(montar); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
